import { defineComponent as _defineComponent } from 'vue'
import ClockComponent from '@/components/common/ClockComponent/ClockComponent.vue';
import Breadcrumb from '@/components/common/Breadcrumb/Breadcrumb.vue';

import './styles/application-toolbar.scss';
import { useRoute } from 'vue-router/composables';
import useStore from '@/utils/store/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationToolbar',
  setup(__props) {

const route = useRoute();
const store = useStore();

function getCurrentUserIsAbleToRead() {
  const featureName = route?.meta?.text;
  return store.getters['permissions/getCurrentUserIsAbleTo']('read', featureName) || store.getters['permissions/getCurrentUserIsAbleTo']('write', featureName);
}


return { __sfc: true,route, store, getCurrentUserIsAbleToRead, ClockComponent, Breadcrumb }
}

})